import React, { useEffect, useState } from "react";
import { Box, Modal, IconButton, useMediaQuery } from "@mui/material";
import { Close } from "@mui/icons-material";
import { enqueueSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { useIds } from "../../hook/AdminContext";
import {
  add_job,
  get_education_list,
  get_experience_list,
  get_job_type_list,
  update_job,
} from "../../DAL/jobs/jobs";
import GeneralCkeditor from "../../components/editors/GeneralCkEditor";
import {
  address_icon_2,
  education_icon,
  job_title_icon,
  job_type_icon,
  salary_icon,
  select_icon,
} from "../../assets";

export default function PostJobHeader({
  open,
  handleClose = () => { },
  refreshlist = () => { },
  loadMorePath,
  loadingstate,
  sourceSLug = null,
  jobData,
  editMode,
}) {
  const [jobTypeList, setJobTypeList] = useState([]);
  const [educationList, setEducationList] = useState([]);
  const [experienceList, setExperienceList] = useState([]);

  const [inputs, setInputs] = React.useState({
    detailed_description: "",
  });
  const [title, setTitle] = useState("");
  const [address, setAddress] = useState("");
  const { userInfo, isRefresh, setIsRefresh, activeSourceList } = useIds();

  const location = useLocation();
  const [jobType, setJobType] = useState("");
  const [chooseTime, setChooseTime] = useState("");
  const [experienceLevel, setExperienceLevel] = useState("");
  const [salaryType, setSalaryType] = useState("fixed");
  const [fixedSalary, setFixedSalary] = useState("");
  const [minSalary, setMinSalary] = useState("");
  const [maxSalary, setMaxSalary] = useState("");
  const [salaryFrequency, setSalaryFrequency] = useState("");
  const [status, setstatus] = useState(true);
  const [selectedFilter, setSelectedFilter] = useState(sourceSLug);
  const [submitting, setSubmitting] = useState(false);

  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: isSmallScreen ? "95%" : "90%",
    maxWidth: isSmallScreen ? "500px" : "900px",
    maxHeight: isSmallScreen ? "80vh" : "95vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    padding: "0px",
    outline: "none",
    display: "flex",
    flexDirection: "column",
  };

  const fetchSourceInfo = (value, list) => {
    let obj = list.find((_obj) => _obj.source_slug == value);

    return {
      title: obj.title,
      slug: obj.source_slug,
      _id: obj._id,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Trimmed inputs
    const trimmedTitle = title.trim();
    const trimmedAddress = address.trim();
    const plainTextDesc = inputs.detailed_description
      .replace(/<[^>]+>/g, "")
      .trim();

    // Title validation
    if (!trimmedTitle || trimmedTitle.length < 3) {
      enqueueSnackbar("Job title must be at least 3 characters", {
        variant: "error",
      });
      return;
    }

    // Address validation
    if (!trimmedAddress || trimmedAddress.length < 3) {
      enqueueSnackbar("Location must be at least 3 characters", {
        variant: "error",
      });
      return;
    }
    if (trimmedAddress.length > 100) {
      enqueueSnackbar("Location is too long (max 100 characters)", {
        variant: "error",
      });
      return;
    }

    // Job Type
    if (!jobType) {
      enqueueSnackbar("Please select a job type", { variant: "error" });
      return;
    }

    // Education
    if (!chooseTime) {
      enqueueSnackbar("Please select required education", { variant: "error" });
      return;
    }

    // Experience
    if (!experienceLevel) {
      enqueueSnackbar("Please select required experience", {
        variant: "error",
      });
      return;
    }

    // Salary Frequency
    if (!salaryFrequency) {
      enqueueSnackbar("Please select a salary frequency", { variant: "error" });
      return;
    }

    // Salary Validation
    if (salaryType === "fixed") {
      if (!fixedSalary || Number(fixedSalary) <= 0) {
        enqueueSnackbar("Fixed salary must be a positive number", {
          variant: "error",
        });
        return;
      }
    } else {
      if (
        !minSalary ||
        Number(minSalary) <= 0 ||
        !maxSalary ||
        Number(maxSalary) <= 0
      ) {
        enqueueSnackbar("Min and Max salary must be positive numbers", {
          variant: "error",
        });
        return;
      }
      if (parseFloat(minSalary) > parseFloat(maxSalary)) {
        enqueueSnackbar("Min salary cannot be greater than Max salary", {
          variant: "error",
        });
        return;
      }
    }

    // Description
    if (!plainTextDesc) {
      enqueueSnackbar("Description is required", { variant: "error" });
      return;
    }

    setSubmitting(true);

    const formData = {
      job_title: trimmedTitle,
      location: trimmedAddress,
      job_type_slug: jobType,
      education_required_slug: chooseTime,
      experience_required_slug: experienceLevel,
      salary_type: salaryType,
      frequency_salary: salaryFrequency,
      description: inputs.detailed_description,
      source_slug: selectedFilter,
      status: status,
    };

    if (salaryType === "fixed") {
      formData.salary = fixedSalary;
    } else {
      formData.min_salary = minSalary;
      formData.max_salary = maxSalary;
    }

    let result;

    if (editMode && jobData?._id) {
      result = await update_job(jobData.job_slug, formData);
    } else {
      if (userInfo.isCompanyProfile) {
        formData.action_id = userInfo._id;
      }
      result = await add_job(formData);
    }

    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      handleClose();
      refreshlist(loadMorePath, "", loadingstate);
      setIsRefresh(!isRefresh);
      setSubmitting(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setSubmitting(false);
    }
  };

  const filteredData = activeSourceList?.filter((item) =>
    userInfo.source?.some((source) => source.source_id === item._id)
  );

  const formFields = [
    {
      label: "Job Title*",
      type: "input",
      placeholder: "Enter job title",
      value: title,
      setValue: setTitle,
      icon: job_title_icon,
    },

    {
      label: "Job Type*",
      type: "select",
      placeholder: "Select job type",
      value: jobType,
      setValue: setJobType,
      icon: job_type_icon,
      options: jobTypeList, // array of { _id, slug, title }
    },
    {
      label: "Experience*",
      type: "select",
      placeholder: "Enter experience required",
      value: experienceLevel,
      setValue: setExperienceLevel,
      icon: job_type_icon,
      options: experienceList,
    },
    {
      label: "Education*",
      type: "select",
      placeholder: "Enter education required",
      value: chooseTime,
      setValue: setChooseTime,
      icon: education_icon,
      options: educationList,
    },
    {
      label: "Location*",
      type: "input",
      placeholder: "Enter job location",
      value: address,
      setValue: setAddress,
      icon: address_icon_2,
    },
    {
      label: "Salary Type*",
      type: "select",
      placeholder: "",
      value: salaryType,
      setValue: setSalaryType,
      icon: salary_icon,
      options: [
        { id: 1, title: "Fixed", slug: "fixed" },
        { id: 2, title: "Range", slug: "range" },
      ],
    },
    {
      label: "Frequency*",
      type: "select",
      placeholder: "Select Frequency",
      value: salaryFrequency,
      setValue: setSalaryFrequency,
      icon: salary_icon,
      options: [
        { id: 1, title: "Hourly", slug: "Hourly" },
        { id: 2, title: "Yearly", slug: "Yearly" },
      ],
    },
  ];

  console.log(selectedFilter, "selectedFilter");
  console.log(userInfo, "selectedFilter");

  useEffect(() => {
    if (editMode && jobData) {
      setInputs({
        detailed_description: jobData.description,
      });
      setTitle(jobData.job_title || "");
      setAddress(jobData.location || "");
      setJobType(jobData.job_type?.slug || "");
      setChooseTime(jobData.education_required?.slug || "");
      setExperienceLevel(jobData.experience_required?.slug || "");
      setSalaryType(jobData.salary_type || "fixed");
      setSalaryFrequency(jobData.frequency_salary);
      setstatus(jobData?.status ?? true);
      setSelectedFilter(jobData?.source?.slug || "");
      // Set salary fields based on type
      if (jobData.salary_type === "fixed") {
        setFixedSalary(jobData.salary || "");
      } else {
        setMinSalary(jobData.min_salary || "");
        setMaxSalary(jobData.max_salary || "");
      }
    } else if (!editMode) {
      // Reset all fields for new job
      setInputs({ detailed_description: "" });
      setTitle("");
      setAddress("");
      setJobType("");
      setChooseTime("");
      setExperienceLevel("");
      setSalaryType("fixed");
      setFixedSalary("");
      setMinSalary("");
      setMaxSalary("");
      setSalaryFrequency("");
      setSelectedFilter(sourceSLug);
      setstatus(true);
    }
  }, [editMode, jobData, open]);

  useEffect(() => {
    const loadData = async () => {
      try {
        // Call DAL functions in parallel
        const [experienceResp, educationResp, jobTypeResp] = await Promise.all([
          get_experience_list(),
          get_education_list(),
          get_job_type_list(),
        ]);

        if (experienceResp.code == 200) {
          setExperienceList(experienceResp.data);
        } else {
          enqueueSnackbar(experienceResp.message, { variant: "error" });
        }

        if (educationResp.code == 200) {
          setEducationList(educationResp.data);
        } else {
          enqueueSnackbar(educationResp.message, { variant: "error" });
        }

        if (jobTypeResp.code == 200) {
          setJobTypeList(jobTypeResp.data);
        } else {
          enqueueSnackbar(jobTypeResp.message, { variant: "error" });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (open) {
      loadData();
    }
  }, []);

  return (
    <div
      style={{
        // padding: isSmallScreen ? "15px" : "10px 20px 20px 20px",
        overflowY: "auto",
        flex: 1,
        paddingBottom: "13px",
      }}
    >
      <form onSubmit={handleSubmit}>
        <div className="row">
          {formFields.map((field, index) => (
            <div
              key={index}
              className={"col-12 col-lg-6 mt-3" + ` ${index < 2 && "mt-lg-0"}`}
            >
              <div className="custom-input-design">
                <label>{field.label}</label>

                <div className="position-relative">
                  {field.type === "input" ? (
                    <input
                      className="ps-5"
                      placeholder={field.placeholder}
                      required
                      value={field.value}
                      onChange={(e) => field.setValue(e.target.value)}
                    />
                  ) : (
                    <select
                      className="px-5"
                      required
                      value={field.value}
                      onChange={(e) => field.setValue(e.target.value)}
                    >
                      {field.placeholder && (
                        <option value="" disabled hidden selected>
                          {field.placeholder}
                        </option>
                      )}

                      {field.options?.map((opt) => (
                        <option key={opt._id} value={opt.slug}>
                          {opt.title}
                        </option>
                      ))}
                    </select>
                  )}
                  <img src={field.icon} className="input-start-icon" alt="" />{" "}
                  {field.type === "select" && (
                    <img
                      src={select_icon}
                      className="input-end-icon pe-none"
                      alt=""
                    />
                  )}
                </div>
              </div>
            </div>
          ))}
          {/* Fixed Salary */}
          {salaryType === "fixed" && (
            <div className="col-12 col-lg-6 mt-3">
              <div className="custom-input-design">
                <label>Fixed Salary*</label>

                <div className="position-relative">
                  <input
                    className="ps-5"
                    type="number"
                    placeholder={"Enter fixed salary"}
                    required
                    value={fixedSalary}
                    onChange={(e) => setFixedSalary(e.target.value)}
                  />

                  <img src={salary_icon} className="input-start-icon" alt="" />
                </div>
              </div>
            </div>
          )}
          {salaryType === "range" && (
            <>
              {/* Min Salary */}
              <div className="col-12 col-lg-3 mt-3">
                <div className="custom-input-design">
                  <label>Min*</label>

                  <div className="position-relative">
                    <input
                      className="ps-5"
                      type="number"
                      placeholder={"Enter min salary"}
                      required
                      value={minSalary}
                      onChange={(e) => setMinSalary(e.target.value)}
                    />

                    <img
                      src={salary_icon}
                      className="input-start-icon"
                      alt=""
                    />
                  </div>
                </div>
              </div>

              {/* Max Salary */}
              <div className="col-12 col-lg-3 mt-3">
                <div className="custom-input-design">
                  <label>Max*</label>

                  <div className="position-relative">
                    <input
                      className="ps-5"
                      type="number"
                      placeholder={"Enter Max salary"}
                      required
                      value={maxSalary}
                      onChange={(e) => setMaxSalary(e.target.value)}
                    />

                    <img
                      src={salary_icon}
                      className="input-start-icon"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {/*  Source */}
          <div className="col-12 col-lg-6 mt-3">
            <div className="custom-input-design">
              <label>Select Source*</label>

              <div className="position-relative">
                <select
                  className="ps-5"
                  placeholder={"Enter Max salary"}
                  required
                  value={selectedFilter}
                  onChange={(e) => setSelectedFilter(e.target.value)}
                >
                  <option value="" disabled hidden selected>
                    Select Source
                  </option>
                  {userInfo?.source?.map((item) => (
                    <option value={item.source_slug}>{item.title}</option>
                  ))}
                </select>
                <img src={salary_icon} className="input-start-icon" alt="" />
                <img
                  src={select_icon}
                  className="input-end-icon pe-none"
                  alt=""
                />
              </div>
            </div>
          </div>

          {/*  Status */}
          <div className="col-12 col-lg-6 mt-3">
            <div className="custom-input-design">
              <label>Status*</label>

              <div className="position-relative">
                <select
                  className="ps-5"
                  placeholder={"Enter Max salary"}
                  required
                  value={status}
                  onChange={(e) => setstatus(e.target.value)}
                >
                  <option value="" disabled hidden selected>
                    Status
                  </option>
                  <option value={true}>Active</option>
                  <option value={false}>Inactive</option>
                </select>
                <img src={salary_icon} className="input-start-icon" alt="" />
                <img
                  src={select_icon}
                  className="input-end-icon pe-none"
                  alt=""
                />
              </div>
            </div>
          </div>
          {/* Description */}
          <div className="col-12 mt-3">
            <div className="custom-input-design">
              <label>Description*</label>

              <GeneralCkeditor
                required
                inputs={inputs}
                setInputs={setInputs}
                name="detailed_description"
                isLimited={true}
              />
            </div>
          </div>
          {/* Submit Button */}
          <div className="col-12 text-end mt-3">
            <button
              type="submit"
              className="theme-button-contained"
              disabled={submitting}
              style={{ minHeight: 50, minWidth: 200 }}
            >
              {editMode
                ? submitting
                  ? "Updating..."
                  : "Update"
                : submitting
                  ? "Posting..."
                  : "Post Job"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
